import { useQuery } from '@apollo/client/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Statistic from '../Statistic';
import GET_STATS from './queries/GetPersistedTotalChats';

const TotalMembers = function () {
  const { partnerId } = useParams();
  const { t } = useTranslation();

  const { data, loading } = useQuery(GET_STATS, {
    variables: { partnerId: partnerId! },
  });

  const totalChats = data?.community?.stats?.totalChats || 0;

  return (
    <Statistic
      title={t('chat:::conversations')}
      value={totalChats}
      loading={loading}
    />
  );
};

export default TotalMembers;
